import React from "react";
import { Container, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import fondImageDesktop from "../../assets/images/appImages/Banniere web lecoransoigne.png";
import fondImageMobile from "../../assets/images/appImages/Banniere web lecoransoignemobile.png";

export interface BannierCoranProps {
  titreLigne1?: string;
  titreLigne2?: string;
  titreAccent?: string;
  description?: string;
  labelBoutonPlein?: string;
  labelBoutonContour?: string;
}

const BannierCoran: React.FC<BannierCoranProps> = ({
  titreLigne1 = "FOI,",
  titreLigne2 = "BIENÊTRE ET",
  titreAccent = "GUÉRISON",
  labelBoutonPlein = "VOIR NOS PRODUITS",
  labelBoutonContour = "VOIR NOS SERVICES",
}) => {
  return (
    <section className="hero-banner ">
      {/* Fond desktop : image complète (Coran + décor), visible seulement > 767px */}
    <img
  src={fondImageDesktop}
  alt=""
  aria-hidden="true"
  className="hero-banner__fond--desktop"
/>

      {/* Fond mobile : image complète (Coran + décor), visible seulement <= 767px */}
      <img
        src={fondImageMobile}
        alt=""
        aria-hidden="true"
        className="hero-banner__fond--mobile"
      />

      <Container fluid className="hero-banner__container">
        <div className="hero-banner__contenu">
          <h1 className="hero-banner__titre">
            {titreLigne1}
            <br />
            {titreLigne2}
            <br />
            <span className="hero-banner__accent">{titreAccent}</span>
          </h1>

       <div className="hero-banner__actions">
  <NavLink to="/a-propos-de-nous" className="text-decoration-none hero-banner__lien">
    <Button variant="outline-success" className="hero-banner__btn hero-banner__btn--contour">
      {labelBoutonContour}
    </Button>
  </NavLink>

  <NavLink to="/produits" className="text-decoration-none hero-banner__lien">
    <Button className="hero-banner__btn hero-banner__btn--plein">
      {labelBoutonPlein}
    </Button>
  </NavLink>
</div>
        </div>
      </Container>
    </section>
  );
};

export default BannierCoran;